var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 16,
    rx: 8,
    fill: "#FFFAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3L8.04673 8.34393C7.87232 8.55321 7.78512 8.65785 7.78379 8.74623C7.78263 8.82306 7.81687 8.89615 7.87663 8.94445C7.94537 9 8.08159 9 8.35402 9H12L11.5 13L15.9533 7.65607C16.1277 7.44679 16.2149 7.34215 16.2162 7.25377C16.2174 7.17694 16.1831 7.10385 16.1234 7.05555C16.0546 7 15.9184 7 15.646 7H12L12.5 3Z",
    stroke: "#F79009",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoor);
export default __webpack_public_path__ + "static/media/poor.12bec3c004c5bc8ac688ab1ce610cae1.svg";
export { ForwardRef as ReactComponent };